import React from 'react';
import styled from 'styled-components';
import { SectionParent, H2 } from '../../StyledComponents';
import AppDevice from '../../../assets/v2/androidx86/group-22.svg';
import ADB from '../../../assets/v2/androidx86/group-14.svg';
import AppVerify from '../../../assets/v2/androidx86/group-23.svg';
import IntuitiveCloud from '../../../assets/v2/androidx86/group-12.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const Section = styled(SectionParent)`
  padding: 0rem 20rem;
  display: grid;
  justify-items: center;
  width: 100%;
  background-color: #1b2341;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding: 0rem 16rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding: 0rem 10rem;
  }
  @media (max-width: 768px) {
    padding-top: 9px;
    padding-left: 4rem;
    padding-right: 4rem;
  }
  @media (max-width: 520px) {
    padding: 1rem;
    padding-bottom: 2rem;
  }
`;
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  width: 100%;
  padding-left: 5rem;
  padding-right: 5rem;
  justify-content: center;
  @media (max-width: 1100px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
  @media (max-width: 520px) {
    padding-left: 0rem;
    padding-right: 0rem;
    padding-top: 0rem;
  }
`;

const GridItem = styled.div`
  grid-column: span 1;
  padding: 2rem;
  min-width: 220px;
  /* margin-right: 1rem;
  margin-left: 1rem; */
  @media (max-width: 768px) {
    padding-top: 4rem;
    flex: 0 0 calc(100%);
    padding-right: 10%;
    padding-left: 10%;
    display: grid;
    justify-items: center;
  }
  @media (max-width: 520px) {
    padding: 1rem;
    min-width: unset;
  }
`;

const GridItemTitle = styled(H2)`
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #b48bcd;

  min-height: 3rem;
  margin-top: 0.5rem;
  margin-bottom: 0.8rem;
  @media (max-width: 1700px) {
    font-size: 18px;
  }
  @media (max-width: 768px) {
    min-height: 0;
  }
  @media (max-width: 520px) {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    font-size: 16px;
  }
  @media (max-width: 375px) {
    font-size: 15px;
  }
`;
const imageStyle = {
  height: '98px',
  width: '86px',
};

const ImgContainer = styled.div`
  display: grid;
  justify-items: center;
`;
export default () => (
  <div>
    <Section>
      <GridContainer>
        <GridItem>
          <ImgContainer>
            <LazyLoadImage
              src={AppDevice}
              alt="Extend the life of x86 installed base"
              style={imageStyle}
            />
          </ImgContainer>
          <GridItemTitle>Extend the life of x86 installed base</GridItemTitle>
        </GridItem>
        <GridItem>
          <ImgContainer>
            <LazyLoadImage
              src={ADB}
              alt="Apply x86 horsepower for innovative solutions"
              style={imageStyle}
            />
          </ImgContainer>
          <GridItemTitle>
            Apply x86 horsepower for innovative solutions
          </GridItemTitle>
        </GridItem>
        <GridItem>
          <ImgContainer>
            <LazyLoadImage
              src={AppVerify}
              alt="Leverage the deep base of x86 hardware"
              style={imageStyle}
            />
          </ImgContainer>
          <GridItemTitle>Leverage the deep base of x86 hardware</GridItemTitle>
        </GridItem>
        <GridItem>
          <ImgContainer>
            <LazyLoadImage
              src={IntuitiveCloud}
              alt=" Intuitive Cloud platform to deploy and manage x86 devices"
              style={imageStyle}
            />
          </ImgContainer>
          <GridItemTitle>
            Intuitive Cloud platform to deploy and manage x86 devices
          </GridItemTitle>
        </GridItem>
      </GridContainer>
    </Section>
  </div>
);
